import React from 'react';

import { cssClass } from '~src/style';

import { DeleteDomainButton } from './DeleteDomainButton';
import { EditDomainButton } from './EditDomainButton';

export type EditDomainCellProps = Readonly<{
    onEditClicked: () => void;
    onDeleteClicked: () => void;
}>;

export function EditDomainCell(props: EditDomainCellProps) {
    const { onEditClicked, onDeleteClicked } = props;
    return (
        <td>
            <span className={'tb-data-grid-cell-text tb-lr-padded-wide ' + editDomainCellClass}>
                <EditDomainButton onClick={onEditClicked} />
                <DeleteDomainButton onClick={onDeleteClicked} />
            </span>
        </td>
    );
}

const editDomainCellClass = cssClass('edit-domain-cell', 'root', {
    float: 'right'
});
